/* Puras Camisetas — theme behaviour */
(function () {
  'use strict';

  var money = function (cents) {
    return window.PC_FORMAT
      ? window.PC_FORMAT.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      : '$' + (cents / 100).toFixed(2);
  };

  /* ---------------------------------------------------------------- Drawer */

  var Drawer = {
    open: function (el) {
      if (!el) return;
      el.hidden = false;
      document.body.style.overflow = 'hidden';
      // The sticky add-to-bag bar must not sit on top of an open sheet.
      document.body.classList.add('drawer-open');
      var focusable = el.querySelector('.drawer__close, .modal__close, [data-drawer-close]:not(.drawer__overlay)');
      if (focusable) focusable.focus();
      Drawer.current = el;
    },
    close: function (el) {
      el = el || Drawer.current;
      if (!el) return;
      el.hidden = true;
      Drawer.current = null;
      if (!document.querySelector('.drawer:not([hidden]), .modal:not([hidden])')) {
        document.body.style.overflow = '';
        document.body.classList.remove('drawer-open');
      }
    },
    closeAll: function () {
      document.querySelectorAll('.drawer:not([hidden]), .modal:not([hidden])').forEach(function (el) {
        el.hidden = true;
      });
      Drawer.current = null;
      document.body.style.overflow = '';
      document.body.classList.remove('drawer-open');
    },
    current: null
  };

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      var target = document.getElementById(openTrigger.getAttribute('data-drawer-open'));
      if (!target) return;
      e.preventDefault();
      Drawer.closeAll();
      Drawer.open(target);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      Drawer.close(e.target.closest('.drawer, .modal'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Drawer.current) Drawer.close();
  });

  /* ------------------------------------------------------------- Mobile nav */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var isOpen = nav.hasAttribute('open');
    if (isOpen) { nav.removeAttribute('open'); } else { nav.setAttribute('open', ''); }
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  /* ------------------------------------------------------------- Size guide */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-modal-open]');
    if (!trigger) return;
    e.preventDefault();
    Drawer.open(document.getElementById(trigger.getAttribute('data-modal-open')));
  });

  /* ---------------------------------------------------------- Variant logic */

  function VariantPicker(root) {
    this.root = root;
    this.form = root.querySelector('form[data-product-form]');
    this.idInput = root.querySelector('[data-variant-id]');
    this.button = root.querySelector('[data-add-button]');
    this.priceEl = root.querySelector('[data-price]');
    this.stockEl = root.querySelector('[data-stock-note]');
    this.notifyEl = root.querySelector('[data-notify]');
    var data = root.querySelector('[data-variant-json]');
    this.variants = data ? JSON.parse(data.textContent) : [];
    this.bind();
    this.update();
  }

  VariantPicker.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('input[name="Size"]').forEach(function (input) {
      input.addEventListener('change', function () { self.update(); });
    });
  };

  VariantPicker.prototype.current = function () {
    var checked = this.root.querySelector('input[name="Size"]:checked');
    if (!checked) return null;
    var value = checked.value;
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].title === value) return this.variants[i];
    }
    return null;
  };

  VariantPicker.prototype.update = function () {
    var v = this.current();
    if (!v) {
      if (this.idInput) this.idInput.value = '';
      if (this.button) { this.button.disabled = true; this.button.textContent = this.variants.some(function (variant) { return variant.available; }) ? 'Choose a size' : this.button.getAttribute('data-soldout-text'); }
      return;
    }

    if (this.idInput) this.idInput.value = v.id;

    document.querySelectorAll('[data-price]').forEach(function (el) {
      el.innerHTML = money(v.price);
    });
    document.querySelectorAll('[data-selected-size]').forEach(function (el) {
      el.textContent = v.size || v.title;
    });
    var inst = document.querySelector('[data-instalment]');
    if (inst) inst.innerHTML = money(Math.round(v.price / 4));
    var skuEl = document.querySelector('[data-sku]');
    if (skuEl && v.sku) {
      skuEl.textContent = skuEl.textContent.replace(/:.*$/, ': ' + v.sku);
    }

    var available = v.available;
    if (this.button) {
      this.button.disabled = !available;
      this.button.textContent = available
        ? this.button.getAttribute('data-add-text')
        : this.button.getAttribute('data-soldout-text');
    }
    var stickyBtn = document.querySelector('[data-sticky-add]');
    if (stickyBtn) stickyBtn.disabled = !available;

    if (this.stockEl) {
      var threshold = parseInt(this.stockEl.getAttribute('data-threshold'), 10) || 0;
      var low = available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= threshold;
      document.querySelectorAll('[data-selected-stock]').forEach(function (el) {
        el.textContent = low ? ': ' + v.inventory_quantity + ' left' : '';
        el.className = low ? 'size-label-stock' : '';
      });
    }

    if (this.notifyEl) this.notifyEl.hidden = available;

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  };

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    new VariantPicker(root);
  });

  /* ------------------------------------------------------------------ Cart */

  function refreshDrawer() {
    return fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + '?section_id=cart-drawer'
      : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var target = document.querySelector('[data-cart-contents]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-count-inline]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (!document.body.hasAttribute('data-cart-drawer')) return;

    e.preventDefault();
    var button = form.querySelector('[data-add-button]');
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[data-variant-id]').value, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(); })
      .then(function () {
        Drawer.open(document.getElementById('CartDrawer'));
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = original; }
      });
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    remove.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(remove.getAttribute('data-line-remove'), 10), quantity: 0 })
    })
      .then(function () { return refreshDrawer(); })
      .catch(function () { window.location.href = '/cart'; });
  });

  /* --------------------------------------------------- Cart quantity stepper */

  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-qty-increase]');
    var decBtn = e.target.closest('[data-qty-decrease]');
    var btn = incBtn || decBtn;
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute(incBtn ? 'data-qty-increase' : 'data-qty-decrease'), 10);
    var valueEl = document.querySelector('[data-qty-value="' + line + '"]');
    var current = valueEl ? (parseInt(valueEl.textContent, 10) || 1) : 1;
    var next = incBtn ? current + 1 : current - 1;
    if (next < 0) next = 0;
    btn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: next })
    })
      .then(function () { return refreshDrawer(); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { btn.disabled = false; });
  });

  /* -------------------------------------------------------- Cart discount code */

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-discount-apply]');
    if (!applyBtn) return;
    e.preventDefault();
    var input = document.querySelector('[data-discount-input]');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.matches('[data-discount-input]')) return;
    e.preventDefault();
    var applyBtn = document.querySelector('[data-discount-apply]');
    if (applyBtn) applyBtn.click();
  });

  /* ------------------------------------------------------ Copy to clipboard */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy]');
    if (!btn) return;
    var text = btn.getAttribute('data-copy');
    var done = function () {
      var original = btn.textContent;
      btn.classList.add('is-copied');
      btn.textContent = 'Copied';
      setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.textContent = original;
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () {});
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(ta);
    }
  });

  /* ------------------------------------------------------------ Bundle bar */

  function fitBundleBar() {
    var bar = document.querySelector('[data-bundle-bar]');
    if (!bar || bar.hidden) return;
    var inner = bar.querySelector('.bundle-bar__inner');
    var content = bar.querySelector('.bundle-bar__content');
    if (!inner || !content) return;
    content.style.transform = 'none';
    var style = window.getComputedStyle(inner);
    var padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
    var available = inner.clientWidth - padding;
    var needed = content.scrollWidth;
    if (available > 0 && needed > available) {
      content.style.transform = 'scale(' + (available / needed) + ')';
    }
  }

  (function () {
    var bar = document.querySelector('[data-bundle-bar]');
    if (!bar) return;
        try { if (localStorage.getItem('pc-bundle-dismissed') === '1') { bar.remove(); return; } } catch (e) {}
    
    document.body.classList.add('has-bundle-bar');

    // iOS Safari tints its own address/tab bar to match whatever page
    // content is docked at the screen edges — that's a real screenshot a
    // client sent showing Safari's OWN toolbar (not a page element) stuck
    // red after this bar was closed. Make it intentional instead of stuck:
    // switch the page's theme-color to match this bar while it's showing,
    // then switch it back the instant the bar is closed.
    var themeColorMeta = document.querySelector('meta[name="theme-color"]');
    var originalThemeColor = themeColorMeta ? themeColorMeta.getAttribute('content') : null;
    if (themeColorMeta) themeColorMeta.setAttribute('content', getComputedStyle(bar).backgroundColor);

    var close = bar.querySelector('[data-bundle-close]');
    if (close) {
      close.addEventListener('click', function () {
                try { localStorage.setItem('pc-bundle-dismissed', '1'); } catch (e) {}
        
        var wrapper = bar.closest('.shopify-section');
        bar.hidden = true;
        bar.style.setProperty('display', 'none', 'important');
        bar.style.background = 'transparent';
        bar.remove();
        if (wrapper && wrapper.children.length === 0) wrapper.remove();
        document.body.classList.remove('has-bundle-bar');
        if (themeColorMeta && originalThemeColor !== null) {
          themeColorMeta.setAttribute('content', originalThemeColor);
        }
        // Also nudge the scroll position (across two animation frames, by a
        // more noticeable amount) so Safari re-samples the edge color right
        // away instead of leaving the old tint cached.
        var y = window.scrollY;
        requestAnimationFrame(function () {
          window.scrollTo(window.scrollX, y + 24);
          requestAnimationFrame(function () {
            window.scrollTo(window.scrollX, y);
          });
        });
      });
    }
    fitBundleBar();
  })();

  /* ------------------------------------- Product card tap preview (touch) */

  (function () {
    // Only touch/coarse-pointer devices get this: real mouse users keep the
    // existing CSS :hover swap untouched (see the matching @media (hover:
    // hover) and (pointer: fine) guards added around the hover rules in
    // theme.css for .card:hover and .ck-pcard:hover).
    if (!window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var ACTIVE = 'is-tap-active';

    function clearActive(except) {
      document.querySelectorAll('.ck-pcard.' + ACTIVE + ', .card.' + ACTIVE).forEach(function (el) {
        if (el !== except) el.classList.remove(ACTIVE);
      });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('.ck-pcard__media a, .card__media');
      if (!link) {
        clearActive(null);
        return;
      }
      var card = link.closest('.ck-pcard, .card');
      if (!card) return;
      if (card.classList.contains(ACTIVE)) return; // second tap: let it navigate normally
      e.preventDefault();
      clearActive(card);
      card.classList.add(ACTIVE);
    });
  })();

  /* ---------------------------------------------- Product gallery dots (mobile) */

  (function () {
    var track = document.getElementById('ProductMedia');
    var dots = document.querySelectorAll('[data-media-dot]');
    if (!track || !dots.length) return;

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-media-dot'), 10);
        var item = track.children[i];
        if (item) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    });
  })();

  /* ------------------------------------------------------- Sticky add to cart */

  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var anchor = document.querySelector('[data-add-button]');
    if (!anchor) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        // show the bar only once the real button has scrolled out of view
        bar.hidden = entries[0].isIntersecting;
        bar.setAttribute('data-anchor-visible', String(entries[0].isIntersecting));
      }, { rootMargin: '0px 0px -20% 0px' }).observe(anchor);
    }

    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      anchor.click();
    });
  })();

  /* ------------------------------------------------------- Gallery load more */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    document.querySelectorAll('.product__media-list .is-extra').forEach(function (li) {
      li.hidden = false;
      li.classList.remove('is-extra');
    });
    btn.remove();
  });

  /* ------------------------------------------------------------ Countdown */

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-end')).getTime();
    if (isNaN(end)) return;
    var clock = el.querySelector('[data-count-clock]');
    var done = el.querySelector('[data-count-done]');
    var out = {};
    el.querySelectorAll('[data-cd]').forEach(function (n) { out[n.getAttribute('data-cd')] = n; });

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        if (clock) clock.hidden = true;
        if (done) done.hidden = false;
        clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      if (out.d) out.d.textContent = Math.floor(s / 86400);
      if (out.h) out.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (out.m) out.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (out.s) out.s.textContent = pad(s % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ----------------------------------------------------------------- Tabs */

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab-target]');
    if (!tab) return;
    var group = tab.getAttribute('data-tab-group');
    document.querySelectorAll('[data-tab-group="' + group + '"]').forEach(function (t) {
      var panel = document.getElementById(t.getAttribute('data-tab-target'));
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', String(on));
      if (panel) panel.classList.toggle('is-hidden', !on);
    });
  });

  /* ------------------------------------------------------ Announcement bar */

  function fitAnnouncementItem(bar, item) {
    if (!bar || !item) return;
    item.style.transform = 'none';
    var style = window.getComputedStyle(bar);
    var padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
    var available = bar.clientWidth - padding;
    var needed = item.scrollWidth;
    if (available > 0 && needed > available) {
      item.style.transform = 'scale(' + (available / needed) + ')';
    }
  }

  var announcementBars = document.querySelectorAll('[data-announcement]');
  announcementBars.forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    var i = 0;
    items.forEach(function (el, idx) { if (el.classList.contains('is-active')) i = idx; });
    fitAnnouncementItem(bar, items[i]);
    if (items.length < 2) return;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
      fitAnnouncementItem(bar, items[i]);
    }, interval);
  });

  var pcFitResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(pcFitResizeTimer);
    pcFitResizeTimer = setTimeout(function () {
      announcementBars.forEach(function (bar) {
        fitAnnouncementItem(bar, bar.querySelector('.announcement__item.is-active'));
      });
      fitBundleBar();
    }, 150);
  });

  /* ------------------------------------------------------------- Carousel */

  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-carousel-next]');
    var prev = e.target.closest('[data-carousel-prev]');
    var btn = next || prev;
    if (!btn) return;
    var id = btn.getAttribute('data-carousel-next') || btn.getAttribute('data-carousel-prev');
    var track = document.getElementById('Carousel-' + id);
    if (!track) return;
    var card = track.querySelector('li');
    var step = card ? card.offsetWidth + 24 : track.clientWidth * 0.8;
    track.scrollBy({ left: next ? step : -step, behavior: 'smooth' });
  });

  /* ------------------------------------------------------------- Quick add */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.getAttribute('data-quick-add'), quantity: 1 }] })
    })
      .then(function () { return refreshDrawer(); })
      .then(function () { Drawer.open(document.getElementById('CartDrawer')); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { btn.disabled = false; btn.textContent = original; });
  });

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-upsell-add]');
    if (!add) return;
    e.preventDefault();
    add.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: add.getAttribute('data-upsell-add'), quantity: 1 }] })
    })
      .then(function () { return refreshDrawer(); })
      .catch(function () { window.location.href = '/cart'; });
  });
})();